import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import React, {useState} from 'react';
import {renderStatusIcon} from './ccLeagueUtils';
import {View, Image, Pressable, StyleSheet} from 'react-native';
import {Colors} from '@/styles';
import ChallengeModal from './ChallengeModal';
import points from '../../../../Assets/Images/Svgs/points.svg';
import {useNavigation} from '@react-navigation/native';
import {setLocalStorage} from '@/Utils/CommonUtils';
import {ScreenName} from '@/navigators/StackConstants';
import Divider from '@/Atoms/Divider/Divider';
import CCTable from '@/Atoms/CCTable';
import Tooltip from '@/Atoms/Tooltip';

const StandingsRow = ({
  standing,
  index,
  selectedRow,
  hoveredRow,
  setSelectedRow,
  setHoveredRow,
  standings,
  goldMedal,
  silverMedal,
  bronzeMedal,
  challengeIcon,
  isMobileOrTab,
  leagueId,
  leagueRules,
  isHeader = false,
}) => {
  const navigation = useNavigation();
  const isRowSelected = !isHeader && selectedRow === index;
  const isRowHovered = !isHeader && hoveredRow === index;
  const [openChallenge, setOpenChallenge] = useState(false);
  const handleCloseChallenge = () => {
    setOpenChallenge(false);
  };
  const handleOpenChallenge = () => {
    setOpenChallenge(true);
  };

  const challengePlayer = () => {
    setLocalStorage('league_opp_id', standing.user_id);
    setLocalStorage('league_id', leagueId);
    navigation.navigate(ScreenName.PlayChess);
  };

  return (
    <>
      <Box
        key={index}
        gap={20}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          borderBottom: '1px solid #5f595833',
          borderRight: isRowSelected ? '1px solid #26232233' : null,
          borderLeft: isRowSelected ? '1px solid #26232233' : null,
          backgroundColor: isRowSelected && Colors.primaryLight,
          backgroundImage: isRowHovered
            ? 'linear-gradient(90deg, rgba(250, 246, 235, 0) 0.37%, #FAF6EB 8.1%, rgba(250, 246, 235, 0) 37.16%)'
            : 'none',
          cursor: isRowHovered ? 'pointer' : 'default',
        }}
        onPress={() => {
          setSelectedRow(isRowSelected ? null : index);
          if (standings.player_name !== 'You') {
            handleOpenChallenge();
          }
        }}
        onMouseEnter={() => setHoveredRow(index)}
        onMouseLeave={() => setHoveredRow(null)}>
        <Box type="row-center" style={styles.status}>
          <Box type="row-flex-start" gap={10}>
            <Box style={styles.ht}>
              <Box type="row-flex-start" style={styles.wrap}>
                {renderStatusIcon(standing.status)}
              </Box>
            </Box>
            <Box style={styles.img}>
              {index === 0 ? (
                <Image source={goldMedal} style={{width: 24, height: 24}} />
              ) : index === 1 ? (
                <Image source={silverMedal} style={{width: 24, height: 24}} />
              ) : index === 2 ? (
                <Image source={bronzeMedal} style={{width: 24, height: 24}} />
              ) : (
                <Box style={styles.idx}>
                  <CCText
                    color={'#4D3F37'}
                    fontWeight={500}
                    fontSize={FontSizes[15]}>
                    {index + 1}.
                  </CCText>
                </Box>
              )}
            </Box>
            <Box type="center" style={styles.rtv}>
              <Image
                source={standing.profile}
                style={{
                  height: 28,
                  width: 28,
                }}
              />
              {standing.online && <Box style={styles.dot} />}
            </Box>
            <CCText
              width={isMobileOrTab ? 200 : 'auto'}
              color={CCColors.Black}
              fontWeight={500}
              showEllipses={true}
              numberOfLines={1}
              fontSize={FontSizes[16]}>
              {standing.player_name}
            </CCText>
            {!isMobileOrTab && (
              <Box type="row-flex-start" gap={10}>
                <>
                  <Box style={styles.rate}>
                    <CCText
                      color={CCColors.Grey.Grey}
                      fontWeight={300}
                      fontSize={FontSizes[8]}>
                      CC RATING
                    </CCText>
                    <CCText
                      color={CCColors.Grey.Grey}
                      fontWeight={500}
                      fontSize={FontSizes[10]}>
                      {standing.rating}
                    </CCText>
                  </Box>
                  {standing.fide_rating > 0 && (
                    <Divider isVertical style={{height: 30}} />
                  )}
                </>

                {standing.fide_rating > 0 && (
                  <>
                    <Box style={styles.rate}>
                      <CCText
                        color={CCColors.Grey.Grey}
                        fontWeight={300}
                        fontSize={FontSizes[8]}>
                        FIDE RATING
                      </CCText>
                      <CCText
                        color={CCColors.Grey.Grey}
                        fontWeight={500}
                        fontSize={FontSizes[10]}>
                        {standing.fide_rating}
                      </CCText>
                    </Box>
                  </>
                )}
              </Box>
            )}
          </Box>
        </Box>
        <Box gap={20} type="row-flex-end" style={styles.flex}>
          <Box type="row-flex-end" gap={20}>
            {!isMobileOrTab && standing.player_name !== 'You' && (
              <View style={{position: 'relative'}}>
                {standing.online ? (
                  <CCButton
                    onPress={challengePlayer}
                    contentContainerStyle={{
                      paddingHorizontal: 30,
                    }}>
                    <Box type="center" flexDirection="row" gap={10}>
                      <Image source={challengeIcon} style={styles.icon} />
                      <CCText fontWeight={500} fontSize={FontSizes[12]}>
                        Challenge
                      </CCText>
                    </Box>
                  </CCButton>
                ) : (
                  <Tooltip
                    text={
                      !standing.online ? (
                        <CCText
                          textAlign="center"
                          color={CCColors.White}
                          fontSize={FontSizes[8]}>
                          Player is offline
                        </CCText>
                      ) : (
                        ''
                      )
                    }
                    children={toggleEvent => (
                      <Pressable
                        onPointerEnter={toggleEvent}
                        onPointerLeave={toggleEvent}>
                        <CCButton
                          disabled={!standing.online}
                          contentContainerStyle={{
                            paddingHorizontal: 30,
                          }}>
                          <Box type="center" flexDirection="row" gap={10}>
                            <Image source={challengeIcon} style={styles.icon} />
                            <CCText fontWeight={500} fontSize={FontSizes[12]}>
                              Challenge
                            </CCText>
                          </Box>
                        </CCButton>
                      </Pressable>
                    )}
                  />
                )}
              </View>
            )}
            {isMobileOrTab && (
              <CCText
                // width={isMobileOrTab ? 'auto' : 80}
                color={CCColors.Black}
                fontSize={FontSizes[13]}>
                {standing?.end_score} pts
              </CCText>
            )}
            {/* </Pressable> */}
          </Box>
        </Box>
        {!isMobileOrTab && (
          <Box type="row-flex-end" gap={10}>
            <Box
              flexDirection="column"
              alignItems="center"
              justifyContent="center">
              <CCText
                style={{paddingRight: 20}}
                fontWeight={300}
                // width={isMobileOrTab ? 'auto' : 80}
                color={CCColors.Grey.Grey}
                fontSize={FontSizes[9]}>
                Score:
              </CCText>
              <CCText
                style={{paddingRight: 20}}
                // width={isMobileOrTab ? 'auto' : 80}
                color={CCColors.Black}
                fontSize={FontSizes[13]}>
                {standing?.end_score} pts
              </CCText>
            </Box>

            {/* <Image source={points} style={{height: 20, width: 20}} /> */}
            <Box
              flexDirection="column"
              alignItems="center"
              justifyContent="center">
              <CCText
                fontWeight={300}
                // width={isMobileOrTab ? 'auto' : 80}
                color={CCColors.Grey.Grey}
                fontSize={FontSizes[9]}>
                Total Score:
              </CCText>
              <CCText
                color={CCColors.Rewards.TextGreen}
                fontWeight={400}
                fontSize={FontSizes[13]}>
                {standing?.cumulative_score} pts
              </CCText>
            </Box>
          </Box>
        )}
      </Box>
      {selectedRow === index && !isMobileOrTab && (
        <CCTable
          headers={leagueRules.map(r => ({key: r.type, label: r.name}))}
          data={[
            leagueRules.reduce((a, b) => {
              a[b?.type] = `${standing?.stats[b?.type] || 0}/${
                b?.computed_max_points ?? b?.max_points
              }`;
              return a;
            }, {}),
          ]}
          headerStyle={styles.header}
        />
      )}
      {selectedRow === index &&
        standing.player_name !== 'You' &&
        isMobileOrTab && (
          <ChallengeModal
            standing={standing}
            hoveredRow={hoveredRow}
            index={index}
            openChallenge={openChallenge}
            handleCloseChallenge={handleCloseChallenge}
            isMobileOrTab={isMobileOrTab}
            challengePlayer={challengePlayer}
            leagueRules={leagueRules}
          />
        )}
    </>
  );
};

const styles = StyleSheet.create({
  headerBox: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    padding: 20,
  },
  rank: {
    width: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dummy: {width: 39},
  proxy: {flex: 1},
  score: {width: 70, alignItems: 'center'},
  total: {
    width: 50,
    alignItems: 'flex-end',
    marginLeft: 20,
    flexWrap: 'wrap',
  },
  custom: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #26232233',
  },
  status: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    padding: 20,
  },
  ht: {
    height: '100%',
  },
  wrap: {
    margin: 'auto',
    width: '100%',
    flexWrap: 'wrap',
  },
  img: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  idx: {
    width: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rtv: {
    width: 39,
    height: 33,
    position: 'relative',
  },
  dot: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    borderRadius: 20,
    width: 13,
    height: 13,
    backgroundColor: CCColors.Green,
    borderColor: CCColors.White,
    borderWidth: 2,
  },
  rate: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 5,
  },
  flex: {
    flexDirection: 'row',
    flex: 0.5,
  },
  icon: {
    height: 16,
    width: 16,
    paddingRight: 8,
  },
  header: {
    textAlign: 'center',
    backgroundColor: 'transparent',
    color: CCColors.TextColor.Grey,
  },
});
export default StandingsRow;
